import React, { useEffect, useState } from "react";
import styles from "./AdProviderConfiguration.module.css";
import Button from "../../component/button/Button";
import InputText from "../../component/inputText/InputText";
import { getAdManagement, postAdManagement } from "../../api/HttpApis";
import { showToast } from "../../utils/Toastify/Toastify";

const AdProviderConfig = () => {
  const [selectedProvider, setSelectedProvider] = useState({
    ad_provider: {
      "Google IMA SDK": {
        publish_id: "",
        tag_url: "",
        targeting_parameter: "",
      },
      freewheel: {
        publish_id: "",
        tag_url: "",
        targeting_parameter: "",
      },
      spotx: {
        publish_id: "",
        tag_url: "",
        targeting_parameter: "",
      },
      custom_tags: {
        publish_id: "",
        tag_url: "",
        targeting_parameter: "",
      },
      adtelligent: {
        publish_id: "",
        tag_url: "",
        targeting_parameter: "",
      },
    },
    pre_roll: false,
    mid_roll: false,
    post_roll: false,
  });

  const [ads, setAds] = useState();
  const [getData, setData] = useState({
    publish_id: "",
    tag_url: "",
    targeting_parameter: "",
  });

  const getAds = async () => {
    const response = await getAdManagement();
    setAds(response?.data);
    setSelectedProvider("Google IMA SDK");
    const obj = response.data["google_ima_sdk"];
    setData({
      publish_id: obj?.publish_id ?? "",
      tag_url: obj?.tag_url ?? "",
      targeting_parameter: obj?.targeting_parameter ?? "",
    });
  };

  const handleValueChange = (item) => {
    const str = item.value.replace(/-/g, "_");
    const obj = ads[str];

    setData({
      publish_id: obj?.publish_id ?? "",
      tag_url: obj?.tag_url ?? "",
      targeting_parameter: obj?.targeting_parameter ?? "",
    });
    setSelectedProvider(item.name);
  };

  useEffect(() => {
    getAds();
  }, []);
  const providers = [
    {
      name: "Google IMA SDK",
      desc: "Interactive Media Ads",
      value: "google-ima-sdk",
    },
    {
      name: "FreeWheel",
      desc: "Comcast Technology Solutions",
      value: "freewheel",
    },
    { name: "SpotX", desc: "Video Advertising Platform", value: "spotx" },
    {
      name: "Custom Tags",
      desc: "Custom VAST/VPAID Implementation",
      value: "custom-tags",
    },
    {
      name: "Adtelligent",
      desc: "VAST Video Ad Network",
      value: "adtelligent",
    },
  ];
  const handleSave = async () => {
     try {
       const obj_key = providers.find((x) => x.name == selectedProvider).value;
       const response = await postAdManagement(ads?.id, {
         ad_provider: {
           [obj_key]: getData,
         },
       });
       if (response?.status === "success") {
         showToast("Configuration saved successfully", "success");
         getAds();
       }
     } catch (error) {
       console.error(error, "error");
     }
  };
  const handleChange = (e, field) => {
    const value = e.target.value;
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className={styles.innerContainer}>
      {/* Top Tabs */}

      <div className={styles.content}>
        {/* Left Section */}
        <div className={styles.leftPanel}>
          <div className={styles.providerTitle}>Select Ad Provider</div>
          {providers.map((p) => (
            <div
              key={p.name}
              className={`${styles.providerCard} ${
                selectedProvider === p.name ? styles.selected : ""
              }`}
              onClick={() => handleValueChange(p)}
            >
              <div>
                <div className={styles.providerName}>{p.name}</div>
                <p className={styles.providerPara}>{p.desc}</p>
              </div>
              {selectedProvider === p.name && (
                <span className={styles.badge}>Selected</span>
              )}
            </div>
          ))}
        </div>

        {/* Right Section */}
        <div className={styles.rightPanel}>
          <div className={styles.providerTitle}>Provider Configuration</div>

          <label>Publisher ID</label>
          <InputText
            type="text"
            placeholder="pub-123456789"
            value={getData?.publish_id}
            onChange={(e) => handleChange(e, "publish_id")}
          />

          <label>Ad Tag URL</label>
          <InputText
            type="text"
            placeholder="https://pubads.g.doubleclick.net/gampad/ads?..."
            value={getData?.tag_url}
            onChange={(e) => handleChange(e, "tag_url")}
          />

          <label>Targeting Parameters</label>
          <InputText
            type="text"
            placeholder="geo=US&age=25-34&interests=sports"
            value={getData?.targeting_parameter}
            onChange={(e) => handleChange(e, "targeting_parameter")}
          />

          <Button className={styles.saveBtn} onClick={handleSave}>
            Save Configuration
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdProviderConfig;
